import appReducer from "./appReducer";
import metaDataReducer from "./metaDataReducer";
import getServicesReducer from "./apiReducers/getServicesReducer";
import { combineReducers } from "redux";
import getDataReducer from "./apiReducers/getDataReducer";
import getDatesReducer from "./apiReducers/getDatesReducer";
import postHarpApplicationReducer from "./apiReducers/postHarpApplicationReducer";
import { authenticate as authenticateReducer } from "./authenticateReducer";
const rootReducer = combineReducers({
  app: appReducer,
  metaData: metaDataReducer,
  servicesReducer: getServicesReducer,
  harpApplicationReducer: postHarpApplicationReducer,
  getDataReducer: getDataReducer,
  authenticate: authenticateReducer,
  datesReducer: getDatesReducer
});

export default rootReducer;
